import React, { useEffect, useRef } from "react";
import { Buttons, GLOBAL_IMAGES, getKnowledgeCards } from "../../assets/asset";
import BigPrimaryButton from "../ui/BigPrimaryButton";
import { useDispatch } from "react-redux";
import { setShowKnowledge } from "../../store/slice/profileSlice";
import useIndiaLocation from "../../hooks/useIndiaLocation";
// Import the ANIMAL_IMAGES object
import { ANIMAL_IMAGES } from "../../assets/components/lessonDashboard/animals";

const boardTexts = [
  "Let's get you started at the foundation level and dive into the <p class='text-5xl my-4'>world of sharks</p> where you'll learn interesting facts and explore numbers.",
  "Let's get you started at the level 1 and dive into the <p class='text-5xl my-4'>world of sheeps</p> where you'll learn graphs and numbers patterns.",
  "Let's get you started at the level 2 and dive into the <p class='text-5xl my-4'>world of cockatoo</p> where you'll learn interesting facts and explore height and weight system.",
  "Let's get you started at the level 3 and dive into the <p class='text-5xl my-4'>world of Possum</p> where you'll learn about fractions and currency.",
  "Let's get you started at the level 4 and dive into the <p class='text-5xl my-4'>world of wallaby</p> where you'll learn interesting facts and explore even & odd numbers.",
  "Let's get you started at the level 5 and dive into the <p class='text-5xl my-4'>world of kangroo</p> where you'll learn about fraction conversion",
  "Let's get you started at the level 6 and dive into the <p class='text-5xl my-4'>world of Crocodile</p> where you'll learn about graphs and unit measurements.",
  "Let's get you started at Level 7 and dive into the world of problem-solving where you'll explore fractions, decimals and percentages, master integer operations and uncover the secrets of angles and shapes.",
  "Welcome to Level 8! It's time to tackle algebra, work with rational and irrational numbers and explore rates, ratios and probability. From calculating best buys to understanding time zones and geometric transformations, this level will sharpen your mathematical thinking.",
  "At Level 9, you're stepping into advanced problem-solving. Explore scientific notation, trigonometry and linear equations while mastering proportional reasoning and probability. Let's dive into real-world applications like interest calculations and coordinate geometry.",
];

export default function Knowledge({ year = 0, closeKnowledge }) {
  function decideImage() {
    switch (year) {
      case 4:
        return {
          source: ANIMAL_IMAGES.activeYear3,
          style: "-bottom-[2.5vw] -left-[2vw]",
        };
      case 5:
        return {
          source: ANIMAL_IMAGES.activeYear4,
          style: "-bottom-[2.5vw] -left-[0.25vw]",
        };
      case 6:
        return {
          source: ANIMAL_IMAGES.activeYear5,
          style: "-bottom-[3.5vw] left-[5vw]",
        };
      case 7:
        return {
          source: ANIMAL_IMAGES.activeYear6,
          style: "bottom-0",
        };
      default:
        return null;
    }
  }

  const dispatch = useDispatch();
  const cardRefs = useRef([]);
  const containerRef = useRef(null);
  const [showFact, setShowFact] = React.useState(true);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const isIndiaLocation = useIndiaLocation();
  const cards = getKnowledgeCards(year, isIndiaLocation);

  const scrollToCard = (index) => {
    const container = containerRef.current;
    const card = cardRefs.current[index];

    if (!container || !card) return;

    container.scrollTo({
      left: card.offsetLeft - container.offsetLeft,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    const nextIndex = activeIndex + 1;

    if (nextIndex >= cards.length) {
      closeKnowledge();
      dispatch(setShowKnowledge(false));
      setActiveIndex(0);
      return;
    }

    setActiveIndex(nextIndex);
    scrollToCard(nextIndex);
  };

  useEffect(() => {
    return () => {
      dispatch(setShowKnowledge(false));
    };
  }, []);

  return (
    <div className="knowledge-overlay w-full absolute z-30 min-h-screen flex items-center justify-center bg-black/80">
      {showFact ? (
        <div className="knowledge-fact-screen flex flex-col gap-[1.5vw] justify-center items-center">
          <img
            src={GLOBAL_IMAGES.foxImage}
            className="knowledge-fox absolute z-40 bottom-0 left-[20%] w-[15vw] h-auto"
          />
          <div className="knowledge-board-wrap relative">
            <img
              src={GLOBAL_IMAGES.boardImage}
              onLoad={() => setImageLoaded(true)}
              className="knowledge-board h-[36rem] md:h-[40vw] lg:h-[36rem] self-center w-auto"
            />
            {imageLoaded && (
              <div
                dangerouslySetInnerHTML={{ __html: boardTexts[year - 1] }}
                className="knowledge-board-text absolute top-[12%] left-[8%] right-[8%] 
             justify-center font-mali text-primary-brown font-bold 
             text-[1.8vw] lg:text-2xl xl:text-3xl text-center"
              />
            )}
            <img
              className="knowledge-animal h-[13.2vw] max-w-60 object-contain lg:h-[10.5rem] w-auto absolute right-[1vw] bottom-[1vw]"
              src={decideImage()?.source}
            />
            <div className="knowledge-fact-action absolute bottom-10 left-[50%] translate-x-[-50%]">
              <BigPrimaryButton
                onClick={() => setShowFact(false)}
                title={"Lets Go"}
              />
            </div>
          </div>

          <div
            onClick={closeKnowledge}
            className="knowledge-close absolute z-50 top-[1vw] right-[1vw]"
          >
            <img
              src={Buttons.cross}
              className="knowledge-close-img h-[4.8vw] lg:h-16 w-[4.8vw] lg:w-16 cursor-pointer"
            />
          </div>
        </div>
      ) : (
        <>
          <div className="knowledge-card-screen flex-col max-h-[80vh] gap-[1.8vw] flex items-center justify-center">
            <div
              ref={containerRef}
              className="knowledge-card-track w-[28.8vw] lg:w-96 overflow-hidden snap-x flex"
            >
              {cards.map((item, index) => (
                <img
                  key={index}
                  ref={(el) => (cardRefs.current[index] = el)}
                  src={item}
                  className="knowledge-card snap-center object-contain mr-[6vw]"
                />
              ))}
            </div>

            <div className="knowledge-card-dots w-[18vw] lg:w-72 flex justify-center gap-[0.9vw]">
              {cards.map((_, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setActiveIndex(index);
                    scrollToCard(index);
                  }}
                  className={`h-[0.9vw] lg:h-4 w-[0.9vw] lg:w-4 rounded-full text-center cursor-pointer ${
                    index === activeIndex ? "bg-slate-300" : "bg-slate-500"
                  } knowledge-card-dot`}
                />
              ))}
            </div>
            <BigPrimaryButton
              onClick={handleNext}
              title={activeIndex === cards.length - 1 ? "Done" : "Next"}
            />
          </div>
          <div
            onClick={closeKnowledge}
            className="knowledge-close absolute top-[1vw] right-[1vw]"
          >
            <img
              src={Buttons.cross}
              className="knowledge-close-img h-[4.8vw] lg:h-16 w-[4.8vw] lg:w-16 cursor-pointer"
            />
          </div>
        </>
      )}
    </div>
  );
}
